<div class="status-indicator" [matTooltip]="statusTooltip">
  <mat-spinner *ngIf="isLoading || currentStatus === statusEnum.running" diameter="20"></mat-spinner>
  <mat-icon *ngIf="!isLoading && currentStatus === statusEnum.queued" color="primary">pending</mat-icon>
  <mat-icon *ngIf="!isLoading && currentStatus === statusEnum.ready" color="primary">check_circle</mat-icon>
  <mat-icon *ngIf="!isLoading && currentStatus === statusEnum.error" color="warn">error</mat-icon>
  <mat-icon *ngIf="!isLoading && currentStatus === statusEnum.interrupted" color="warn">block</mat-icon>
</div>
